<template>
  <div>
      <b-row>
        <b-col cols="12" sm="11" md="4" lg="3">
          <a-menu style="width: auto" mode="vertical" v-model="defaultSelectedKeys">
            <a-menu-item key="1">
              <a-icon type="lock" theme="twoTone" twoToneColor="#eb2f96"/>Cambiar contraseña
            </a-menu-item>
            <a-menu-item key="3" v-show="(this.isRoleValid.includes(consts.rolesText.ESTUDIANTE) || this.isRoleValid.includes(consts.rolesText.DOCENTE) || this.isRoleValid.includes(consts.rolesText.ADMIN_ACADEMICO) || this.isRoleValid.includes(consts.rolesText.PSICOLOGO) || this.isRoleValid.includes(consts.rolesText.COORDINADOR)) && this.academicModule">
              <a-icon type="book" />Perfil acádemico
            </a-menu-item>
            <a-menu-item key="4">
              <a-icon type="notification" /> Notificaciones
            </a-menu-item>
            <a-menu-item key="5" v-if="(!this.isRoleValid.includes(consts.rolesText.VISITANTE) && this.cafeteriaModule)">
              <a-icon type="setting" /> Parámetros
            </a-menu-item>
            <a-menu-item key="2" v-show="(this.isRoleValid.includes(consts.rolesText.ESTUDIANTE) || this.isRoleValid.includes(consts.rolesText.PADRE_MADRE)) && this.academicModule">
              <a-icon type="profile" />Matrícula en línea
            </a-menu-item>
            <a-menu-item key="6" v-show="(this.isRoleValid.includes(consts.rolesText.ADMIN) || this.isRoleValid.includes(consts.rolesText.ADMIN_RESTAURANTE)) && this.cafeteriaModule">
              <a-icon type="highlight"/> Códigos
            </a-menu-item>
          </a-menu>
        </b-col>
        <b-col cols="12" sm="11" md="8" lg="9" class="pl-lg-0">
          <b-form @submit="save" v-show="defaultSelectedKeys[0]==='1'">
            <div class="row">
              <div class="col-md-12">
                <b-form-group id="input-group-1" label="Contraseña actual:" label-for="input-1">
                  <a-input-password type="password" autocomplete="current-password" id="input-1" v-model="form.currentPassword" required placeholder="Contraseña actual"></a-input-password>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group id="input-group-2" label="Nueva contraseña:" label-for="input-2">
                  <a-input-password type="password" autocomplete="new-password" id="input-2" v-model="form.newPassword" required placeholder="La contraseña debe tener mínimo de 6 caracteres y contener al menos 1 caracter numerico y 1 letra" :state="passwordValid"
                    aria-describedby="input-live-feedback"></a-input-password>
                  <small class="text-danger" v-show="form.newPassword.length > 0 && !passwordValid">{{passwordValidMsg}}</small>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group id="input-group-3" label="Confirmar nueva contraseña:" label-for="input-3">
                  <a-input-password type="password" autocomplete="new-password" id="input-3" v-model="form.newPasswordConfirm" required placeholder="Confirmar nueva contraseña" :state="passwordConfirm"
                    aria-describedby="input-live-feedback"></a-input-password>
                  <small class="text-danger" v-show="form.newPasswordConfirm.length > 0 && !passwordConfirm">{{passwordConfirmMsg}}</small>
                </b-form-group>
              </div>
            </div>
            <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3" :disabled="saveButtonActive">Guardar cambios</b-button>
          </b-form>
          <enrollmentStudent v-if="defaultSelectedKeys[0]==='2'"></enrollmentStudent>
          <a-tabs v-model="tabActive" :activeKey="tabActive" v-if="defaultSelectedKeys[0]==='3'">
            <a-tab-pane tab="Proyectos acádemicos" :key="1" />
            <a-tab-pane tab="Logros y reconocimientos" :key="2" />
          </a-tabs>
          <academicProjectList v-if="defaultSelectedKeys[0]==='3' && tabActive===1"></academicProjectList>
          <academicProfile v-if="defaultSelectedKeys[0]==='3' && tabActive===2"></academicProfile>
          <userNotification v-if="defaultSelectedKeys[0]==='4'"/>
          <paramUser v-if="defaultSelectedKeys[0]==='5'"/>
          <codeAdmin v-if="defaultSelectedKeys[0]==='6'"/>
        </b-col>
      </b-row>
  </div>
</template>
<script>
import { consts, showErrorMessage } from '@/services/utilities'
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import enrollmentStudent from '@/components/custom/enrollmentStudent'
import academicProjectList from '@/components/custom/academicProjectList'
import academicProfile from '@/components/custom/academicProfile'
import userNotification from '../../../components/custom/userNotification'
import paramUser from '@/components/custom/paramUser'
import codeAdmin from '@/components/custom/codeAdmin'
import store from 'store'

export default {
  components: {
    enrollmentStudent,
    academicProjectList,
    academicProfile,
    userNotification,
    paramUser,
    codeAdmin,
  },
  name: 'settingsProfile',
  data() {
    return {
      passwordValidMsg: 'La contraseña debe tener al menos 1 caracter numerico, 1 letra y mínimo de 8 caracteres en total.',
      passwordConfirmMsg: 'La contraseña no coincide con la anterior',
      defaultSelectedKeys: ['1'], // selecciona el primer item del menu
      isStudent: false,
      isRoleValid: [],
      form: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
      },
      studentInfo: {},
      tabActive: 1,
      consts,
      academicModule: false,
    }
  },
  created() {
    const userData = JSON.parse(store.get('userData'))
    this.isRoleValid = userData.roles
    this.academicModule = userData.school.academicModule
    this.cafeteriaModule = userData.school.cafeteriaModule
  },
  computed: {
    ...mapState(['user']),
    passwordValid: function() {
      // if (this.form.newPassword.length === 0) {
      //   return false
      // }
      return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d.]{8,}$/.test(this.form.newPassword) && this.form.newPassword.length > 5
    },
    passwordConfirm: function() {
      // if (this.form.newPasswordConfirm.length === 0) {
      //   return false
      // }
      return this.form.newPassword === this.form.newPasswordConfirm
    },
    saveButtonActive: function() {
      return !(this.form.currentPassword.length > 0 && this.passwordValid && this.passwordConfirm)
    },
  },
  methods: {
    save(evt) {
      evt.preventDefault()
      apiClient.patch('/users/' + this.$store.state.user.id, this.form).then(response => {
        this.form.currentPassword = ''
        this.form.newPassword = ''
        this.form.newPasswordConfirm = ''
        this.$notification.success({
          message: 'Cambios guardados',
        })
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(error),
        })
      })
    },
  },
}
</script>
